export enum InvoiceType {
  SELL = 'sell',
  RENEWAL = 'renewal',
  UPGRADE = 'upgrade',
}
